export default function NoRoute() {
  return <div>404</div>;
}
